import Grid from '@material-ui/core/Grid';
import { FormControl, Button/* , FormControlLabel, Checkbox */ } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import * as React from 'react';
import AddClusterComponent from './AddClusterComponent';
import TextEditorComponent from '../common/editor/TextEditorComponent';

export default class PageComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showHideDescription: false,
            page: {},
            clusters: [],
            pageTitle: '',
            pageDescription: '',
            errors: {}
        };

        this.handleCluster = this.handleCluster.bind(this);
        this.handlePageTitle = this.handlePageTitle.bind(this);
        this.handlePageDescription = this.handlePageDescription.bind(this);
        this.onBlurHandlePageTitle = this.onBlurHandlePageTitle.bind(this);
        this.updateHtmlFromEditor = this.updateHtmlFromEditor.bind(this);
    }

    handlePageTitle(e: any) {
        this.setState({ pageTitle: e.target.value });
        delete this.state.errors[`page_${this.state.page.page_number}`];
    }

    onBlurHandlePageTitle = () => {
        this.props.updateModule({ data: { pageNumber: this.props.currentPage.page_number, value: this.state.pageTitle }, field: 'pageTitle' });
    }

    handlePageDescription(e: any) {
        this.setState({ pageDescription: e.target.value });
    }

    componentWillMount() {
        this.setState({
            page: this.props.currentPage,
            clusters: this.props.currentPage.question_clusters,
            pageTitle: this.props.currentPage.title.en,
            pageDescription: this.props.currentPage.page_description && this.props.currentPage.page_description.en,
            errors: this.props.errors
        });
    }

    componentWillReceiveProps(nextProps: any) {
         if (nextProps.currentPage) {
            const checkPageDescription = nextProps.currentPage.page_description && nextProps.currentPage.page_description.en;
            this.setState({
                page: nextProps.currentPage,
                clusters: nextProps.currentPage.question_clusters,
                pageTitle: nextProps.currentPage.title.en,
                pageDescription: checkPageDescription === '<p><br></p>' ? '' : checkPageDescription,
                errors: nextProps.errors
            });
        }
    }

    handleCluster = (e: any) => {
        this.props.updateModule({ data: this.state.page.page_number, field: 'addCluster' })
    }

    updateHtmlFromEditor(htmlData: any) {
        if (htmlData) {         
            htmlData = htmlData.replace(/<a/g,'<a target="_blank"');
            this.props.updateModule({ data: { pageNumber: this.props.currentPage.page_number, value: htmlData.toString() }, field: 'pageDescription' })
        }
    }

    render() {

        return (
            <>
                <div className="contentSection">
                    <Grid container={true} spacing={16}>
                        <Grid item={true} xs={12}>
                            <Grid container={true} spacing={16} direction={"row"} alignItems={"center"} justify={"space-between"}>
                                <Grid item={true} xs={7}>
                                    <div className="pageTitleDiv">
                                        <FormControl margin="normal" required={true} fullWidth={true}>
                                            <InputLabel htmlFor="pageTitle">Page Title</InputLabel>
                                            <Input id="pageTitle" name="pageTitle" value={this.state.pageTitle} autoFocus={true}
                                                onChange={this.handlePageTitle}
                                                onBlur={this.onBlurHandlePageTitle}
                                            />
                                            {
                                                this.state.errors && this.state.errors[`page_${this.state.page.page_number}`] && (
                                                    <span className="error" >Page title is mandatory</span>
                                                )

                                            }
                                        </FormControl>
                                        <FormControl margin="normal" required={false} fullWidth={true} >
                                            <InputLabel htmlFor="pageDescription">Page Description</InputLabel>
                                        </FormControl>
                                        <TextEditorComponent updateHtmlFromEditor={this.updateHtmlFromEditor} htmlInput={this.state.pageDescription} />
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item={true} xs={12}>
                            {
                                this.state.clusters
                                    .map((qc: any, index: any) => {
                                        return <div key={'cluster_' + this.props.pageNumber + index} className="cluster">
                                            <AddClusterComponent
                                                pageNumber={this.state.page.page_number}
                                                cluster={qc}
                                                clusterIndex={index}
                                                allData={this.props.allData}
                                                moduleId={this.props.moduleId}
                                                errors={this.state.errors}
                                                modules={this.props.modules}
                                                getModuleList={this.props.getModuleList}
                                                updateModule={this.props.updateModule}
                                                onDeletePageChange={this.props.onDeletePageChange}
                                                userId={this.props.userId}
                                            />
                                        </div>
                                    })
                            }
                        </Grid>
                    </Grid>
                </div>
                <footer className="footerSection">
                    <div className="alignLeft addCluster">
                        <Button type="button" className="btn-blue" variant="outlined" value="Add Cluster" color="default" onClick={this.handleCluster}>Add Cluster</Button>
                    </div>
                    <div className="grow" />
                </footer>

            </>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/PageComponent.tsx